// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import CodeMirror from 'codemirror';
import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/addon/edit/matchtags';
import 'codemirror/mode/meta';
import 'codemirror/addon/dialog/dialog.js';
import 'codemirror/addon/search/searchcursor.js';
import 'codemirror/addon/search/search.js';

const importAll = r => {
    r.keys().forEach(r);
};
importAll(require.context('codemirror/mode/', true, /\.js$/));

CodeMirror.loadMode = function (instance, mode) {
    instance.setOption('mode', mode);
};

export { CodeMirror };



// WEBPACK FOOTER //
// ./components/CodeEditor/CodeMirror.js